import { useState } from "react";
import { BsInfoCircle } from "react-icons/bs";
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { EditorState } from 'draft-js';
import 'draft-js/dist/Draft.css';

const EmailDraft = () => {
    const [editorState, setEditorState] = useState(EditorState.createEmpty());

    const onEditorStateChange = (newState) => {
        setEditorState(newState);
    };
    
    return (
        <div className="px-5 py-5  border d-flex flex-column row-gap-4 " style={{ height: "92%", marginLeft: 45 }}>
            <div className="d-flex flex-column row-gap-3">
                <label className="fw-semibold fs-4 text-black">To</label>
                <input className="form-control" style={{ height: 48 }} />
            </div>

            <div className="d-flex flex-column row-gap-3">
                <label className="fw-semibold fs-4 text-black" >CC</label>
                <input className="form-control" style={{ height: 48 }} />
            </div>

            <div className="d-flex flex-column row-gap-3">
                <label className="fw-semibold fs-4 text-black">BCC</label>
                <input className="form-control" style={{ height: 48 }} />
            </div>

            <div className="d-flex flex-column row-gap-3" >
                <label className="fw-semibold fs-4 text-black">Subject<BsInfoCircle style={{ marginLeft: 10 }} /></label>
                <input className="form-control" style={{ height: 48 }} />
            </div>

            <div className="h-50 w-100 d-flex flex-column row-gap-3 overflow-hidden" style={{borderRadius: 5}}>
                <label className="fw-semibold fs-4 text-black">Body</label>
                <div className="border h-100" style={{overflowY: 'scroll'}}>
                    <Editor
                        editorStyle={{ padding: 10, border: '1pz solid blue'   }}
                        editorState={editorState}
                        toolbarClassName="toolbarClassName"
                        wrapperClassName="wrapperClassName"
                        editorClassName="editorClassName"
                        onEditorStateChange={onEditorStateChange}
                        placeholder="Start typing here..."
                    />
                </div>

            </div>
        </div>
    )
}

export default EmailDraft